import { Posthog, POSTHOG_EVENTS } from '@salescore/client-base'
import { createFileRoute, useNavigate, useRouter } from '@tanstack/react-router'
import { type ReactNode, useEffect } from 'react'

const Page = (): ReactNode => {
  const navigate = useNavigate()
  const { organizationId } = Route.useParams()
  const router = useRouter()
  const { href } = router.buildLocation({ to: '/o/$organizationId/v2', params: { organizationId } })

  useEffect(() => {
    Posthog.track(POSTHOG_EVENTS.access_v1_url, {
      organizationId,
      redirectPath: href,
    })
    void navigate({ to: '/o/$organizationId/v2', params: { organizationId } })
  }, [href, navigate, organizationId])
  return null
}

export const Route = createFileRoute('/o/$organizationId/')({
  component: Page,
})
